module.exports = __webpack_public_path__ + "static/media/person_cluster.0b1004b6.svg";